import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from '../../Header';
import { Icon } from '@iconify/react';
import axios from 'axios';
import { Apis, BaseUrl } from '../../../redux/config';
import { getSession } from '../../../redux/actions/authActions';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubscriptions } from '../../../redux/actions/dbactions/walletActions';

export const ManageSubscriptions = ({
  showAll = false,
  redirectionUrl = '/dashboard/subscriptions',
  // userId = false,
}) => {
  const history = useHistory();
  const {
    token,
    // , user_profile_id
  } = getSession();
  // const id = userId ? userId : user_profile_id;
  const { allSubscriptions, isLoadingAllSubscriptions, activeSubscription } =
    useSelector((state) => state.wallet);
  const dispatch = useDispatch();
  const [cancellingId, setCancellingId] = useState(null);

  const handleCancellation = async (subscription_id, price_id) => {
    setCancellingId(subscription_id);
    try {
      const postData = {
        subscription_id,
        recurring_payment_id: price_id,
      };
      const response = await axios.post(
        `${BaseUrl}${Apis.cancelSubscription}`,
        postData,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.result.rec) {
        dispatch(getAllSubscriptions());
      } else {
        throw new Error(response.data.result.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setCancellingId(null);
    }
  };

  return (
    <>
      {showAll && (
        <Header
          pageTitle="Wallet > Subscriptions"
          icon={
            <Icon icon="material-symbols-light:account-balance-wallet-outline" />
          }
        />
      )}
      <div>
        <div className="flex justify-between items-center bg-white p-3 md:p-4 pb-1">
          <h2 className="text-xl md:text-2xl font-bold">
            Manage My eWallet Subscriptions
          </h2>
          {!showAll && (
            <button
              onClick={() => history.push(redirectionUrl)}
              className="text-blue-700 hover:underline font-semibold text-xs md:text-base"
            >
              Show All
            </button>
          )}
        </div>
        {isLoadingAllSubscriptions ? (
          <p className="text-center py-4">Loading...</p>
        ) : (
          <ul className="px-3 md:px-4 flex flex-col gap-4">
            {activeSubscription ? (
              <li className="flex justify-between items-center shadow-md p-4 rounded-lg border-[1px] border-gray-200 border-blue-500 bg-blue-200">
                <div>
                  <span className="text-gray-800 font-semibold">
                    Start:{' '}
                    {new Date(
                      activeSubscription.start_date
                    ).toLocaleDateString()}
                  </span>
                  <p className="text-gray-800 font-semibold">
                    Due:{' '}
                    {new Date(
                      activeSubscription.next_payment_date
                    ).toLocaleDateString()}
                  </p>
                  <span className="px-2 py-1 rounded-lg text-white bg-blue-600">
                    {activeSubscription.status.charAt(0).toUpperCase() +
                      activeSubscription.status.slice(1)}
                  </span>
                </div>
                <div className="flex flex-col items-end">
                  <p className="text-xl font-bold text-blue-600">
                    ${activeSubscription.amount}
                  </p>
                  {activeSubscription.status !== 'cancelled' && (
                    <button
                      className="bg-red-500 text-white px-3 py-1 rounded-lg mt-2 hover:bg-red-600 transition"
                      onClick={() =>
                        handleCancellation(
                          activeSubscription.subscription_id,
                          activeSubscription.id
                        )
                      }
                      disabled={
                        cancellingId === activeSubscription.subscription_id
                      }
                    >
                      {cancellingId === activeSubscription.subscription_id
                        ? 'Cancelling...'
                        : 'Cancel Subscription'}
                    </button>
                  )}
                </div>
              </li>
            ) : null}
            {allSubscriptions.length > 0
              ? allSubscriptions.map((payment) => (
                  <li
                    key={payment.id}
                    className="flex justify-between items-center shadow-md p-4 rounded-lg bg-white border border-gray-200"
                  >
                    <div>
                      <span className="text-gray-800 font-semibold">
                        Start:{' '}
                        {new Date(payment.start_date).toLocaleDateString()}
                      </span>
                      <p className="text-gray-800 font-semibold">
                        Due:{' '}
                        {new Date(
                          payment.next_payment_date
                        ).toLocaleDateString()}
                      </p>
                      <span className="px-2 py-1 rounded-lg text-white bg-blue-600">
                        {payment.status.charAt(0).toUpperCase() +
                          payment.status.slice(1)}
                      </span>
                    </div>
                    <div className="flex flex-col items-end">
                      <p className="text-xl font-bold text-blue-600">
                        ${payment.amount}
                      </p>
                    </div>
                  </li>
                ))
              : !activeSubscription && (
                  <p className="text-center py-4">No subscriptions found.</p>
                )}
          </ul>
        )}
      </div>
    </>
  );
};
